import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { UserDefinedForm } from '@/components/UserDefinedForm/UserDefinedForm';
export type ContactUsFromProps = {
  onCompleteMessage?: string;
  vehicleStockId?: string;
  siteId?: number;
};
export function ContactUsFrom(t0) {
  const $ = _c(14);
  const {
    onCompleteMessage,
    vehicleStockId,
    siteId
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      id: 1,
      className: "EditableFormStep",
      name: "ContactWrapperPageStart",
      title: "First Page",
      sort: 1,
      required: false,
      showOnLoad: true,
      displayRulesConjunction: "Or",
      layout: "Stacked",
      showTitle: false
    };
    t2 = {
      id: 41,
      className: "EditableFieldGroup",
      name: "ContactWrapperGroupStart",
      title: "Top",
      sort: 2,
      required: false,
      showOnLoad: true,
      displayRulesConjunction: "Or",
      layout: "Grid",
      showTitle: false,
      showFieldSet: false
    };
    t3 = {
      id: 2,
      className: "EditableTextField",
      name: "FirstName",
      title: "First name",
      sort: 3,
      required: true,
      showOnLoad: true,
      displayRulesConjunction: "Or",
      minLength: 0,
      maxLength: 0,
      rows: 1,
      autocomplete: "off"
    };
    t4 = {
      id: 4,
      className: "EditableTextField",
      name: "LastName",
      title: "Last name",
      sort: 4,
      required: true,
      showOnLoad: true,
      displayRulesConjunction: "Or",
      minLength: 0,
      maxLength: 0,
      rows: 1,
      autocomplete: "off"
    };
    t5 = {
      id: 43,
      className: "EditableTextField",
      name: "Phone",
      title: "Phone",
      sort: 5,
      required: true,
      showOnLoad: true,
      displayRulesConjunction: "Or",
      minLength: 0,
      maxLength: 0,
      rows: 1,
      autocomplete: "off"
    };
    t6 = {
      id: 44,
      className: "EditableEmailField",
      name: "Email",
      title: "E-mail",
      sort: 6,
      required: true,
      showOnLoad: true,
      displayRulesConjunction: "Or"
    };
    t7 = {
      id: 42,
      className: "EditableFieldGroupEnd",
      name: "ContactWrapperGroupEnd",
      sort: 8,
      required: false,
      showOnLoad: true,
      displayRulesConjunction: "Or"
    };
    t8 = {
      id: 45,
      className: "EditableTextField",
      name: "Message",
      title: "Message",
      sort: 9,
      required: true,
      showOnLoad: true,
      displayRulesConjunction: "Or",
      minLength: 0,
      maxLength: 0,
      rows: 10,
      autocomplete: "off"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== vehicleStockId) {
    t9 = [t1, t2, t3, t4, t5, t6, t7, t8, {
      id: 46,
      className: "EditableHiddenField",
      name: "StockId",
      title: "StockId",
      sort: 9,
      required: false,
      showOnLoad: true,
      displayRulesConjunction: "Or",
      default: vehicleStockId
    }];
    $[8] = vehicleStockId;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = onCompleteMessage || "<p>Thanks, we&apos;ve received your submission.</p>";
  let t11;
  if ($[10] !== siteId || $[11] !== t10 || $[12] !== t9) {
    t11 = <UserDefinedForm formClassName="ContactUsForm" formId={0} fields={t9} siteId={siteId} onCompleteMessage={t10} showClearButton={false} enableLiveValidation={true} submitButtonText="Submit" clearButtonText="" />;
    $[10] = siteId;
    $[11] = t10;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
}